export default "__VITE_ASSET__CcgxM2I___"